import React from "react"

import classNames from "classnames"

interface ProductPageHeaderProps
  extends React.HTMLAttributes<HTMLHeadingElement> {}

export const ProductPageHeader = React.memo(
  React.forwardRef<HTMLHeadingElement, ProductPageHeaderProps>(
    ({ className, children, ...props }, ref) => {
      return (
        <h1
          ref={ref}
          className={classNames("product-page__header", className)}
          {...props}
        >
          {children}
        </h1>
      )
    }
  )
)
